var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 10.633C4.16699 9.50149 4.16699 8.93576 4.39571 8.43848C4.62443 7.9412 5.05396 7.57302 5.91304 6.83667L6.74637 6.12239C8.29913 4.79145 9.07552 4.12598 10.0003 4.12598C10.9251 4.12598 11.7015 4.79145 13.2543 6.12239L14.0876 6.83667C14.9467 7.57302 15.3762 7.9412 15.6049 8.43848C15.8337 8.93576 15.8337 9.50149 15.8337 10.633V14.1666C15.8337 15.738 15.8337 16.5236 15.3455 17.0118C14.8573 17.5 14.0717 17.5 12.5003 17.5H7.50033C5.92898 17.5 5.1433 17.5 4.65515 17.0118C4.16699 16.5236 4.16699 15.738 4.16699 14.1666V10.633Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0837 17.5V13.5C12.0837 12.9477 11.6359 12.5 11.0837 12.5H8.91699C8.36471 12.5 7.91699 12.9477 7.91699 13.5V17.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8c689901a93062761e8389039111449d.svg";
export { ForwardRef as ReactComponent };